import React from 'react';
import { componentService } from 'js/services/component.service';

export const ClientIp = React.lazy(() => import(/* webpackChunkName: "client-ip" */ './ClientIp'));

// <hub2-client-ip></hub2-client-ip>
componentService.registerWebContentComponents({ ClientIp });
